import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, isLoading } = useAuthStore();
  const navigate = useNavigate();

  // Set page title
  useEffect(() => {
    document.title = 'Login - Translator';
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Invalid credentials';
      setError(errorMessage);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-purple-200 to-white dark:from-dark-base dark:to-dark-elevated font-sans text-gray-800 dark:text-gray-100">
      {/* Login card */}
      <div className="w-full max-w-sm bg-white/70 dark:bg-dark-elevated/90 backdrop-blur-xl shadow-lg rounded-2xl p-8 border border-transparent dark:border-dark-border">
        {/* Logo */}
        <div className="mb-6 flex flex-col items-center">
          <img src="/tec-logo-circle.png" alt="TEC Logo" className="w-24 h-24 object-contain mb-4" />
          <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Translator</h1>
        </div>

        {/* Error message */}
        {error && (
          <div className="mb-4 p-3 bg-red-100 dark:bg-red-900/30 border border-red-400 dark:border-red-800 text-red-700 dark:text-red-400 rounded-lg text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="username" className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
              Username
            </label>
            <input
              id="username"
              name="username"
              type="text"
              required
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                if (error) setError(''); // Clear error when user starts typing
              }}
              className="w-full rounded-lg border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-recessed px-3 py-2 focus:ring-2 focus:ring-purple-400/40 dark:focus:ring-purple-500/40 focus:border-purple-400 dark:focus:border-purple-500 outline-none transition-all text-gray-800 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500"
              placeholder="Enter username"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
              Password
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (error) setError(''); // Clear error when user starts typing
              }}
              className="w-full rounded-lg border border-gray-300 dark:border-dark-border bg-white dark:bg-dark-recessed px-3 py-2 focus:ring-2 focus:ring-purple-400/40 dark:focus:ring-purple-500/40 focus:border-purple-400 dark:focus:border-purple-500 outline-none transition-all text-gray-800 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500"
              placeholder="Enter password"
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full mt-2 px-4 py-2 rounded-lg bg-purple-500 dark:bg-purple-600 text-white font-medium shadow hover:shadow-lg hover:bg-purple-600 dark:hover:bg-purple-500 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            {isLoading ? (
              <>
                <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Signing in...
              </>
            ) : (
              'Sign in'
            )}
          </button>
        </form>



        <p className="text-xs text-center text-gray-400 dark:text-gray-500 mt-4">
          © 2025 The Evaluation Company.
        </p>
      </div>
    </div>
  );
}
